//deps
import styled from "styled-components";

const SIDE_PADDING_WITH_STAMP = "112px";

export const HeaderContainer = styled.div<{ isLottieAnimation?: boolean }>`
    width: 100%;
    position: ${(props) => props.isLottieAnimation && "relative"};
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const HeaderContentWrapper = styled.div<{
    isThemeChange: boolean;
    isGiftingCartFlow?: boolean;
    showAddressWidgetTop?: boolean;
    isJioHotstarFlow?: boolean;
    isMroFlow?: boolean;
}>`
    display: flex;
    width: 100%;
    height: 100%;
    background: ${(props) => (props.isThemeChange ? "transparent" : props.theme.colors.light.background_Primary)};
    position: static;
    padding-top: ${(props) => (props.isJioHotstarFlow ? props.theme.spacing.x5 : props.theme.spacing.medium)};
    z-index: ${(props) => (props.isGiftingCartFlow ? 1 : undefined)};
    align-items: ${(props) => (props.isMroFlow || !props.showAddressWidgetTop) && "center"};
`;

export const HeaderExtensionWrapper = styled.div<{
    isBlack?: boolean;
    hasStamp?: boolean;
}>`
    margin: 10px 0 ${(props) => props.theme.spacing.small};
    width: ${(props) => (props.hasStamp ?? false) && `calc(100vw - ${SIDE_PADDING_WITH_STAMP})`};
`;

export const IconContainer = styled.div<{ isQuickCheckout?: boolean }>`
    padding: 0 ${(props) => props.theme.spacing.small} 0 ${(props) => props.theme.spacing.medium};
    margin-left: -1px;
    z-index: 400;
`;
